import React from 'react';

import { ServerCommunicationUtil } from '../../../utils/server_communication_util';

const recordingStatusDictionary = { A: 'Active', D: 'Deleted' };
class RecordingSearchInterface extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      recordings: [],
      errorMessage: null,
      searchInProgress: false
    };
  }

  retrieveUser = () => {
    const inputData = this.state.searchKey;
    const options = {};
    if (inputData.match(/^\d+$/)) {
      options.user_id = inputData;
    } else if (inputData.indexOf('@')) {
      options.email = inputData;
    } else {
      console.error('Invalid search input');
      return;
    }

    this.setState({
      recordings: [],
      errorMessage: null,
      searchInProgress: true
    });
    ServerCommunicationUtil.getApiEndpoint(
      '/api/alltrails/recording_search',
      options,
      data => {
        this.handleResults(data);
      },
      data => {
        this.setState({
          recordings: [],
          errorMessage: 'An error occurred',
          searchInProgress: false
        });
      },
      () => {}
    );
  };

  handleResults(data) {
    if (data.maps && data.maps.length > 0) {
      const sortedMaps = data.maps.sort((a, b) => {
        return a.id < b.id;
      });
      this.setState({ recordings: sortedMaps, searchInProgress: false });
    } else {
      this.setState({
        errorMessage: 'User has no recordings',
        searchInProgress: false
      });
    }
  }

  replaceRecordingAtIndex(recording, index) {
    const currentRecordings = this.state.recordings;
    currentRecordings[index] = recording;
    this.setState({ recordings: currentRecordings });
  }

  updateSearchKey = e => {
    this.setState({ searchKey: e.target.value.trim() });
  };

  undeleteRecording(trackId, index, e) {
    e.preventDefault();
    e.stopPropagation();

    ServerCommunicationUtil.postApiEndpoint(
      `/api/alltrails/maps/${trackId}/metadata`,
      { detail: 'shallow', status: 'A' },
      data => {
        this.replaceRecordingAtIndex(data.maps[0], index);
      },
      err => {
        console.error(err);
      },
      () => {}
    );
  }

  revertRecordingEdits(trackId, index, e) {
    e.preventDefault();
    e.stopPropagation();

    ServerCommunicationUtil.putApiEndpoint(
      `/api/alltrails/maps/${trackId}/endpoint/revert`,
      {},
      data => {
        this.replaceRecordingAtIndex(data.maps[0], index);
      },
      err => {
        console.error(err);
      },
      () => {}
    );
  }

  renderDisplayContainer() {
    if (this.state.recordings.length > 0) {
      const recordingDivs = this.state.recordings.map((i, index) => this.renderRecordingDiv(i, index));
      const { user } = this.state.recordings[0];
      return (
        <div>
          <h3>{`${user.firstName} ${user.lastName}'s Activity`}</h3>
          <table className="lifeline-history">
            <tbody>
              <tr>
                <th>Map ID</th>
                <th>Title</th>
                <th>Created Time</th>
                <th>Status</th>
                <th>Edited</th>
                <th>Link</th>
              </tr>
              {recordingDivs}
            </tbody>
          </table>
        </div>
      );
    }
    return null;
  }

  renderRecordingDiv(currentRecording, index) {
    let formattedStart = new Date(currentRecording.metadata.created);
    formattedStart = formattedStart.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
    return (
      <tr>
        <td>{currentRecording.id}</td>
        <td>{currentRecording.name}</td>
        <td>{formattedStart}</td>
        <td>
          {recordingStatusDictionary[currentRecording.metadata.status]}{' '}
          {currentRecording.metadata.status === 'D' && <a onClick={this.undeleteRecording.bind(this, currentRecording.id, index)}>(Undelete)</a>}
        </td>
        <td>
          {currentRecording.wasModified ? 'Yes ' : 'No'}
          {currentRecording.wasModified && <a onClick={this.revertRecordingEdits.bind(this, currentRecording.id, index)}>(Revert)</a>}
        </td>
        <td>
          <a href={`/explore/recording/${currentRecording.slug}`} target="_blank">
            Link
          </a>
        </td>
      </tr>
    );
  }

  render() {
    let statusText = null;
    if (this.state.errorMessage !== null) {
      statusText = <p className="user-info-centered feedback-text">{this.state.errorMessage}</p>;
    }

    let findButton = (
      <button className="btn green rounded simple" onClick={this.retrieveUser} type="button">
        Find User
      </button>
    );
    if (this.state.searchInProgress) {
      findButton = (
        <div className="btn green rounded simple disabled" disabled>
          Searching...
        </div>
      );
    }

    return (
      <div className="edition-details">
        <div className="trail-edit-form">
          <div className="field clear contains-separator">
            <div className="floatleft user-info-centered">
              <div>
                <label>Find Recordings for this user:</label>
                <input value={this.state.searchKey} onChange={this.updateSearchKey} placeholder="Enter email or user Id" className="email-inputs" />
              </div>
              {findButton}
            </div>
          </div>
          {statusText}
          {this.renderDisplayContainer()}
        </div>
      </div>
    );
  }
}

export default RecordingSearchInterface;
